import { Typography } from "render/ui/presentation/Typography";
import { ActionButton } from "render/ui/trigger/ActionButton/ActionButton";
import { CheckInBadge } from "../../../__shared/CheckInBadge/CheckInBadge";
import { CheckInStepExplanationLayout } from "../../../__shared/CheckInStepExplanationLayout";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

interface ConsentRequiredStudiesExplanationProps {
  onDone: () => void;
}

export function ConsentRequiredStudiesExplanation({
  onDone,
}: ConsentRequiredStudiesExplanationProps) {
  return (
    <CheckInStepExplanationLayout
      actionsSticky
      SubHeader={<CheckInBadge />}
      Content={
        <div className={styles.text}>
          <div className={styles.header}>
            <Typography variant="display-s">
              <Trans.Header />
            </Typography>
          </div>
          <Typography variant="title-m">
            <Trans.DescriptionPart1 />
          </Typography>
          <Typography variant="title-m">
            <Trans.DescriptionPart2 />
          </Typography>
        </div>
      }
      Actions={
        <ActionButton onClick={onDone}>
          <Trans.Review />
        </ActionButton>
      }
    />
  );
}
